import { Track } from '@/services/track'
import { SampleResumeService } from '@/services/sample-resume-service'
import { Notify } from '@rh/shared/utils/notify'
import { attr, html, on, TNode } from '@tempots/dom'

export function SampleResumeLink(
  {
    setResumeFile,
  }: {
    setResumeFile: (file: File) => void
  },
  ...children: TNode[]
) {
  return html.a(
    attr.class('text-teal-700 underline cursor-pointer hover:text-teal-800'),
    on.click(async () => {
      Track.click({
        section: 'home_drop_zone',
        element_type: 'link',
        click_action: 'navigate',
        element_id: 'sample_resume',
      })
      try {
        const sampleFile = await SampleResumeService.fetchSampleResume()
        setResumeFile(sampleFile)
      } catch (error) {
        Notify.error('Failed to load sample resume')
        console.error('Error loading sample resume:', error)
        Track.clientError({
          error_code: 'SAMPLE_RESUME_FETCH_FAILED',
          error_message: 'Failed to load sample resume',
        })
      }
    }),
    ...children
  )
}
